import NavBar from "../components/NavBar";
import MainGraph from "../components/MainGraph";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

function SeriesPage() {
    const { sectorId, seriesId } = useParams();
    const [sectors, setSectors] = useState([]);
    const [seriesData, setSeriesData] = useState(null);
    const [loadingSectors, setLoadingSectors] = useState(true);
    const [loadingSeries, setLoadingSeries] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch("https://econ-dashboard-live.onrender.com/gics_data")
            .then(res => res.json())
            .then(data => {
                const formatted = Object.entries(data).map(([id, value]) => ({
                    id,
                    ...value
                }));
                setSectors(formatted);
                setLoadingSectors(false);
            })
            .catch(err => {
                setError("Server may be waking up...");
                setLoadingSectors(false);
            });
    }, []);

    useEffect(() => {
        fetch(`https://econ-dashboard-live.onrender.com/series/${seriesId}`)
            .then(res => res.json())
            .then(data => {
                const raw = data[seriesId];
                const formatted = Object.entries(raw).map(([date, value]) => ({
                    date,
                    value
                }));
                setSeriesData({
                    title: seriesId,
                    data: formatted
                });
                setLoadingSeries(false);
            })
            .catch(err => {
                setError("Server may be waking up...");
                setLoadingSeries(false);
            });
    }, []);

    const currentSector = sectors.find(sector => sector.id === sectorId);
    const seriesArray = currentSector ? Object.values(currentSector.series) : [];

    return (
        <div>
            <NavBar sectors={sectors} />
            <main>
                {(loadingSectors && sectors.length === 0) || loadingSeries ? <p>⏳ Loading data... (server may be waking up)</p> : null}
                {error && <p>{error}</p>}
                {!error && !loadingSectors && !loadingSeries && (
                    <>
                        {currentSector?.series[seriesId] && (
                            <h1 style={{ marginLeft: "1rem" }}>
                                {currentSector.series[seriesId].series_description}
                            </h1>
                        )}
                        {currentSector?.series[seriesId] && (
                            <h3 style={{ marginLeft: "1rem" }}>
                                Frequency: {currentSector.series[seriesId].frequency}
                            </h3>
                        )}
                        {currentSector?.series[seriesId] && (
                            <div>
                                <MainGraph 
                                    series={seriesId}
                                    seriesMeta={currentSector?.series}
                                    allSectors={sectors}
                                />
                            </div>
                        )}
                    </>
                )}
            </main>
        </div>
    )
}

export default SeriesPage;